import { Button } from 'antd';
import React, { Component } from 'react';
import {
  changeMenu,
  onResetLayerAll,
  showMenuPopup,
} from '../../../redux/actions/menu.action';
import { LocalStore } from '../../../utils/LocalStore';
import { connect } from 'react-redux';

import './header-style.scss';
import { resetMapLayer } from '../../../redux/actions/map.action';

const userIcon = (
  <svg
    width='25'
    height='25'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M20 3.33337C16.7675 3.33952 13.6065 4.28556 10.902 6.05627C8.19762 7.82698 6.06649 10.3459 4.76824 13.3063C3.46998 16.2667 3.06063 19.5407 3.59004 22.7296C4.11946 25.9185 5.5648 28.8846 7.75 31.2667C9.3107 32.9585 11.2049 34.3086 13.3132 35.2321C15.4216 36.1555 17.6983 36.6323 20 36.6323C22.3017 36.6323 24.5784 36.1555 26.6868 35.2321C28.7951 34.3086 30.6893 32.9585 32.25 31.2667C34.4352 28.8846 35.8805 25.9185 36.41 22.7296C36.9394 19.5407 36.53 16.2667 35.2318 13.3063C33.9335 10.3459 31.8024 7.82698 29.0979 6.05627C26.3935 4.28556 23.2325 3.33952 20 3.33337ZM20 33.3334C16.5474 33.3281 13.2315 31.9838 10.75 29.5834C11.5034 27.7493 12.7851 26.1805 14.4321 25.0765C16.0791 23.9725 18.0172 23.383 20 23.383C21.9828 23.383 23.9209 23.9725 25.5679 25.0765C27.2149 26.1805 28.4966 27.7493 29.25 29.5834C26.7685 31.9838 23.4526 33.3281 20 33.3334ZM16.6667 16.6667C16.6667 16.0074 16.8622 15.363 17.2284 14.8148C17.5947 14.2666 18.1153 13.8394 18.7244 13.5871C19.3335 13.3348 20.0037 13.2688 20.6503 13.3974C21.2969 13.526 21.8908 13.8435 22.357 14.3097C22.8232 14.7759 23.1407 15.3698 23.2693 16.0164C23.3979 16.663 23.3319 17.3332 23.0796 17.9423C22.8273 18.5514 22.4001 19.072 21.8519 19.4383C21.3037 19.8045 20.6593 20 20 20C19.1159 20 18.2681 19.6489 17.643 19.0237C17.0179 18.3986 16.6667 17.5508 16.6667 16.6667ZM31.5167 26.6667C30.0275 24.1196 27.7357 22.1384 25 21.0334C25.8486 20.0711 26.4015 18.8845 26.5924 17.6158C26.7834 16.3471 26.6041 15.0502 26.0763 13.8809C25.5484 12.7115 24.6943 11.7193 23.6165 11.0233C22.5387 10.3273 21.283 9.95712 20 9.95712C18.717 9.95712 17.4613 10.3273 16.3835 11.0233C15.3057 11.7193 14.4516 12.7115 13.9237 13.8809C13.3959 15.0502 13.2166 16.3471 13.4075 17.6158C13.5985 18.8845 14.1514 20.0711 15 21.0334C12.2643 22.1384 9.97245 24.1196 8.48333 26.6667C7.29657 24.6452 6.66953 22.3441 6.66667 20C6.66667 16.4638 8.07142 13.0724 10.5719 10.572C13.0724 8.07147 16.4638 6.66671 20 6.66671C23.5362 6.66671 26.9276 8.07147 29.4281 10.572C31.9286 13.0724 33.3333 16.4638 33.3333 20C33.3305 22.3441 32.7034 24.6452 31.5167 26.6667Z'
      fill='#E5E5E5'
    />
  </svg>
);
class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLogin: false,
    };
  }

  componentDidMount() {
    this.setState({
      isLogin: this.isLogged(),
    });
  }

  isLogged = () => {
    let token = LocalStore.getInstance().read('loginSession');
    if (token) return true;
    return false;
  };

  render() {
    return (
      <div className='main-layout' id='main-header'>
        <div className='header'>
          <div
            className='left-col'
            onClick={() => {
              this.props.onResetLayerAll();
              this.props.changeMenu(false);
              this.props.history.push('/');
              this.props.showMenuPopup(false);
            }}
          >
            <img src='/images/icon-login.png' className='icon-img' alt=''></img>
            <div className='title-text'>
              {this.isLogged()
                ? 'PHẦN MỀM QUẢN LÝ THÔNG TIN QUY HOẠCH KIẾN TRÚC'
                : 'CỔNG THÔNG TIN QUY HOẠCH KIẾN TRÚC THÀNH PHỐ ĐÀ NẴNG'}
            </div>
          </div>

          <div
            className='right-col'
            onClick={() => {
              if (this.state.isLogin) {
                this.props.history.push('/nguoi-dung');
              } else {
                this.props.history.push('/dang-nhap');
              }
            }}
          >
            {this.state.isLogin ? (
              <div className='button-link'>
                {LocalStore.getInstance().read('HoVaTen')}
              </div>
            ) : (
              <Button type='link' className='button-link'>
                Đăng nhập
              </Button>
            )}

            {userIcon}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isShowMenuPopup: state.menu.isShowMenuPopup,
  };
};

const mapDispatchToProps = {
  changeMenu: changeMenu,
  showMenuPopup: showMenuPopup,
  onResetLayerAll: onResetLayerAll,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
